export default "__VITE_ASSET__9f20683d__"